import script from "./GreenButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GreenButton.vue?vue&type=script&setup=true&lang=ts"

import "./GreenButton.vue?vue&type=style&index=0&id=520a8ddc&lang=scss"

const __exports__ = script;

export default __exports__